const API = {
  TOKEN: {
    ACCESS: `auth/api/token/`,
    REFRESH: `auth/api/token/refresh/`
  },
  SCHEMATISATION: {
    STAB_SCHEMATISATION: {
      INDEX: '/stab_schematisations/'
    }
  },
  BOUNDARY_CONDITION: {
    BURSTING_PARAMETER: {
      INDEX: '/bursting_parameters/',
      BULK_UPLOAD: '/bursting_parameters/bulk_upload/',
      TEMPLATE: (id) => `/bursting_parameters/template/${id}/`,
      EXPORT: (id) => `/bursting_parameters/export/${id}/`,
      IMPORT: (id) => `/bursting_parameters/import/revision_id/${id}/`
    },
    BURSTING_PARAMETER_REVISION: {
      INDEX: '/bursting_parameter_revision/'
    }
  },
  SPECKLE: {
    PROJECT_SPECKLE: {
      INDEX: 'speckle/',
      FETCH_PROJECT_SPECKLE: (id) => `speckle/?search=${id}`
    },
    COMMUNICATION_SPECKLE: {
      SEND: (id) => `projects/${id}/send_to_speckle/`
    },
    VISUALIZATION_SPECKLE: {
      GET_GI_VISUALIZATION_DATA: (id) => `dike_profiles/${id}/get_gi_visualization_data/`
    }
  }
}

export default API
